module.exports = __webpack_public_path__ + "media/icons/pdf-96ae4caf.svg";